import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import template from './textEdit.jsx';
import displayNames from '../displayNames';
import compose from '../../hoc/compose';
import withClickOutside from '../../hoc/withClickOutside';
import KEYS from '../../common/keyCodes';

var validate = function validate(validators, value) {
  var invalid = _.find(validators, function (_ref) {
    var validator = _ref.validator;
    return !validator(value);
  });

  return invalid && invalid.invalidMessage;
};

var TextEdit = /*#__PURE__*/function (_React$Component) {
  _inherits(TextEdit, _React$Component);

  var _super = _createSuper(TextEdit);

  function TextEdit(props) {
    var _this;

    _classCallCheck(this, TextEdit);

    _this = _super.call(this, props);
    _this.state = {
      value: props.value,
      invalidMessage: validate(props.validators, props.value)
    };

    _this.onInputTextChange = function (newVal) {
      _this.setState({
        value: newVal,
        invalidMessage: validate(props.validators, newVal)
      });
    };

    _this.isInvalid = function () {
      return !_.isUndefined(_this.state.invalidMessage);
    };

    _this.handleOnChange = function () {
      if (!_this.isInvalid()) {
        _this.applyChanges();
      }
    };

    _this.handleKeyDown = function (e) {
      if (_.includes([KEYS.ENTER, KEYS.ESC], e.keyCode)) {
        e.stopPropagation();
        e.preventDefault();

        if (e.keyCode === KEYS.ESC) {
          _this.props.cancel();
        } else {
          _this.handleOnChange();
        }
      }
    };

    _this.applyChanges = function () {
      return _this.props.onChange(_this.state.value);
    };

    return _this;
  }

  _createClass(TextEdit, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.onClickOutside(this.handleOnChange);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.keyboardShortcuts) {
        window.addEventListener('keydown', this.handleKeyDown, true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.keyboardShortcuts) {
        window.removeEventListener('keydown', this.handleKeyDown, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return TextEdit;
}(React.Component);

TextEdit.displayName = displayNames.SORT_BY_DRAG_LIST_TEXT_EDIT;
TextEdit.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  maxLength: PropTypes.number,
  validators: PropTypes.arrayOf(PropTypes.shape({
    validator: PropTypes.func.isRequired,
    invalidMessage: PropTypes.string.isRequired
  })),
  placeholder: PropTypes.string,
  shouldTranslateInvalidMessage: PropTypes.bool,
  autoFocus: PropTypes.bool,
  keyboardShortcuts: PropTypes.bool,
  buttonText: PropTypes.node
};
TextEdit.defaultProps = {
  autoFocus: false,
  shouldTranslateInvalidMessage: true,
  keyboardShortcuts: false
};
export default compose(TextEdit, [withClickOutside]);